import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { getDesign } from '@state/design';
import { NavController } from '@ionic/angular';
import { IDesign } from 'rebus-models';
import { environment } from '@app/env';

@Component({
  selector: 'app-error500',
  templateUrl: './error500.page.html',
  styleUrls: ['./error500.page.scss'],
})
export class Error500Page implements OnInit {

  public design$: Observable<IDesign>;

  constructor(
    private store: Store<{}>,
    private navCtrl: NavController
  ) { }

  public ngOnInit() {
    this.design$ = this.store.select(getDesign);
  }

  public onGoHome() {
    this.navCtrl.navigateForward(window.localStorage.getItem(`${environment.clientId}-HOMEPAGE`) || environment.redirectTo);
  }

}
